'use strict';

var Sugar = require('sugar-core'),
    stringEach = require('./internal/stringEach');

Sugar.String.defineInstance({

  'forEach': function(str, search, eachFn) {
    return stringEach(str, search, eachFn);
  }

});

module.exports = Sugar.String.forEach;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/forEach.js
// module id = 896
// module chunks = 0